import { useState } from "react";

const faqs = [
  {
    question: "How do I publish my research on Axionnest?",
    answer:
      "To publish, log in to your account, click on 'Add New', select the type of content (journal, thesis, etc.), fill in the details, and click 'Submit'.",
  },
  {
    question: "Is there a limit to how many publications I can add?",
    answer:
      "No, Axionnest allows unlimited publications. Share as much content as you'd like to help others learn from your research.",
  },
  {
    question: "How do I search for specific journals or users?",
    answer:
      "Use the search bar at the top of the homepage. You can search by keywords, author names, or publication types.",
  },
  {
    question: "Can I edit or delete my publication?",
    answer:
      "Yes. Go to your profile, find the publication, and use the edit or delete options available under each post.",
  },
  {
    question: "How do I contact support if I face an issue?",
    answer:
      "If you need help, please use the Contact Us form or email us at support@axionnest.com. We usually respond within 24 hours.",
  },
];

const HelpCenter = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <div className="w-16 h-16 bg-[#e8f0f7] rounded-xl flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Help Center</h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Find answers to common questions and get help with using Axionnest.
        </p>
      </div>

      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <div
            className={`border rounded-xl transition-all duration-200 ${
              activeIndex === index 
                ? "border-[#0f6abf] shadow-sm bg-white" 
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex items-center justify-between p-5 cursor-pointer">
              <span className="text-base font-medium text-gray-900">
                {faq.question}
              </span>
              <span className={`text-gray-500 transition-transform duration-200 ${activeIndex === index ? "rotate-180" : ""}`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </div>
            {activeIndex === index && (
              <div className="px-5 pb-5 pt-0 border-t border-gray-100">
                <div className="flex items-start gap-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full mt-1"></div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpCenter;

